import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Post } from 'src/app/shared/models/posts/post';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-task-puzzle',
  templateUrl: './task-puzzle.component.html',
  styleUrls: ['./task-puzzle.component.scss']
})
export class TaskPuzzleComponent implements OnInit {
  @Input() post: Post;

  public audioOk: any;
  public answers = [];
  public parts: Array<any> = []; 
  public showDialogOk: boolean = false;
  private _colors = ['#96CCCC', '#1A99CE', '#45BC92', '#CCDB2A', '#F7981C', '#4A57A6'];
  constructor(
    private _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.audioOk = new Audio();
    this.audioOk.src = "./assets/okrzyk.mp3";
    this._activatedRoute.params.subscribe(
      params => {
        this.parts = [];
        this.answers = [];
        this.closeDialog();
        this._prepareParts();
      }
    );
  }
  
  drop(event: CdkDragDrop<string[]>) {    
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      let regex = new RegExp('^part-');   
      if (event.container.data.length !== 0 && regex.test(event.container.id)) {       
        let tmp = event.container.data[0];
        event.container.data[0] = event.previousContainer.data[event.previousIndex];
        event.previousContainer.data[event.previousIndex] = tmp;       
      } else {
        transferArrayItem(event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex);
      }
    }
    this._checkWord();
  }

  public closeDialog() {
    this.showDialogOk = false;
  }

  public showDialog() {
    return this.showDialogOk;
  }

  private _prepareParts() {
    let parts: Array<any> = [];
    this.post.randomPuzzleParts().forEach((part) => {
      const random = Math.floor(Math.random() * this._colors.length);
      this.parts.push({
        color: this._colors[random],
        text: part
      })
    });
    for (let i = 0; i < this.post.game_puzzle_count; i++) {
      this.answers.push([]);
    };     
  }

  private _checkWord() {
    let word: string = '';
    this.answers.forEach((parts) => {
      if (parts.length) {
        word += parts[0].text;
      }
    });    
    if (this.post.game_puzzle_password === word) {
      this.audioOk.play();
      this.showDialogOk = true;      
    }
  }
}
